import { observable, action, runInAction, makeObservable } from 'mobx';
import reviewResponseAPI from './api';


class RespondToReviewStore {
  review;

  showRespondUI = false;

  //TODO - switch me back to false
  canRespond = true;

  responseDraft = "";

  isLoading = false;

  constructor(review){
    makeObservable(this, {
      review: observable,
      showRespondUI: observable,
      canRespond: observable,
      responseDraft: observable,
      isLoading: observable,
      onRespondClick: action,
      onCancelClick: action,
      onDraftChange: action,
      submitReviewResponse: action,
      updateReviewResponse: action,
      rejectReviewResponse: action,
      removeReviewResponse: action
    });

    this.review = review;
  }
  //TODO - move this to back in to workflow RespondToReview component
  onRespondClick = () => {
    this.showRespondUI = true;
  };

  onCancelClick = () => {
    this.showRespondUI = false;
  };


  onDraftChange = (value) => {
    this.responseDraft = value;
  };

  returnResponse(response) {
    //Good ole different model formats
    return {
      ...response.reviewResponse,
      ...{_id: { $oid: response.reviewResponse.id }, detail: response.reviewResponse.responseDetail, username: response.reviewResponse.responseUserName, date: response.reviewResponse.responseDate , dateAdded: response.reviewResponse.responseDate }
    }
  }

  submitReviewResponse = () => {
    this.isLoading = true;
    return reviewResponseAPI.submitReviewResponse(this.review._id || this.review.id, this.responseDraft, true)
      .then(response => {
        runInAction(()=> {
          this.isLoading = false;
          this.responseDraft = '';
        });

        return this.returnResponse(response);
      });
  };

  updateReviewResponse = (response, publish = true) => {
    this.isLoading = true;
    return reviewResponseAPI.updateReviewResponse(this.review._id || this.review.id, response._id.$oid, response.detail, publish).then(response => {
      runInAction(() => {
        this.isLoading = false;
        this.review = response.updatedReview;
      });
      return this.returnResponse(response);
    })
  };

  rejectReviewResponse = (response, note = "") => {

    let reasonPromise;
    if(note){
      reasonPromise = reviewResponseAPI.addNote(this.review._id || this.review.id, response._id.$oid, note)
    }else{
      reasonPromise = new Promise(resolve => resolve());
    }
    return Promise.all([reviewResponseAPI.removeResponse(this.review._id || this.review.id, response._id.$oid, note).then(() => {
      runInAction(() => {
        // track down where these things are
      });
      return response;
    }), reasonPromise]);
  };

  removeReviewResponse = (response) => {
    return reviewResponseAPI.removeResponse(this.review._id || this.review.id, response._id.$oid)

  };

}

export default RespondToReviewStore;